<div class="item-header">
  <app-list-item-header [item]="item"></app-list-item-header>
</div>

<hr />

<div class="item-content" (click)="selectItem.emit(item.urlFragment)">
  <div class="item-title" [style.direction]="item.translation.direction">{{ item.title }}</div>

  <div class="item-message">
    <app-hub-item-message [style.direction]="item.translation.direction" [content]="item.message">
    </app-hub-item-message>
  </div>

  @if (item.attachments) {
    <app-attachments
      [attachments]="item.attachments"
      (openAttachment)="openAttachment.emit($event)"
      (getThumb)="getThumb.emit($event)">
    </app-attachments>
  }

  <div class="goto">
    <ion-button type="button" class="ph-btn-white" (click)="showSlipFunction($event)">
      <span class="gotoText">View Slip</span>
    </ion-button>
  </div>
</div>

<hr />

<div class="item-author">
  <app-payment-publisher
    [item]="item"
    [showPublisherLink]="showPublisherLink"
  (selectPaymentRequests)="selectPaymentRequests.emit($event)"></app-payment-publisher>
</div>

<hr />
